import { Link } from "react-router-dom";
import { Sprout, MapPin, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-line bg-obsidian">
    <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-3 gap-14">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <Sprout className="w-5 h-5 text-saffron" />
          <span className="font-display text-2xl text-zinc-100">
            The Garlic <span className="italic text-saffron">Hog</span>
          </span>
        </div>
        <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
          A down-to-earth family farm growing nature's abundant luxury — hardneck Asiatic garlic and
          semi-exotic vegetables, from our soil to your table.
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <span className="overline-tag">Wander</span>
        <Link to="/shop" data-testid="footer-shop-link" className="text-sm text-zinc-400 hover:text-saffron transition-colors w-fit">The Harvest</Link>
        <Link to="/seasons" data-testid="footer-seasons-link" className="text-sm text-zinc-400 hover:text-saffron transition-colors w-fit">Season Calendar</Link>
        <Link to="/gallery" data-testid="footer-gallery-link" className="text-sm text-zinc-400 hover:text-saffron transition-colors w-fit">Gallery</Link>
        <Link to="/tours" data-testid="footer-tours-link" className="text-sm text-zinc-400 hover:text-saffron transition-colors w-fit">Book a Farm Tour</Link>
        <Link to="/garden-sage" data-testid="footer-garden-sage-link" className="text-sm text-zinc-400 hover:text-saffron transition-colors w-fit">The Garden Sage — our app</Link>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-zinc-600 hover:text-saffron transition-colors w-fit mt-4">Farm Gate (Family Login)</Link>
      </div>
      <div className="flex flex-col gap-4">
        <span className="overline-tag">Find Us</span>
        <p className="flex items-center gap-3 text-sm text-zinc-400">
          <MapPin className="w-4 h-4 text-saffron shrink-0" /> Mount Albert, Ontario, Canada
        </p>
        <a
          href="mailto:thegarlichog@gmail.com"
          data-testid="footer-email-link"
          className="flex items-center gap-3 text-sm text-zinc-400 hover:text-saffron transition-colors w-fit"
        >
          <Mail className="w-4 h-4 text-saffron shrink-0" /> thegarlichog@gmail.com
        </a>
        <p className="text-sm text-zinc-400">Wholesale &amp; chef enquiries welcome — B2B garlic is our bread and butter.</p>
      </div>
    </div>
    <div className="border-t border-line py-6 text-center text-xs text-zinc-600 tracking-[0.2em] uppercase">
      © {new Date().getFullYear()} The Garlic Hog · thegarlichog.com · Grown, not manufactured
    </div>
  </footer>
);
